<template>
  <div :class="['grid-section', {'model-open':(modelData !== null)}]">
    <div class="content_filters">
      <div class="visible-xs">
        <ul class="nav nav-tabs content_tabs_mobile">
          <!-- <li @click="showfilter('select_4G')" :class="['li_select_4G', {'addborder': (activeTabsMobile === 'select_4G')}]">
            <img src="~images/project/icon/4g_icon.svg" alt="" />
          </li> -->
          <li @click="showfilter('select_age')" :class="['li_select_age', {'addborder': (activeTabsMobile === 'select_age')}]">
            <img src="~images/project/icon/age_icon.svg" alt=""/>
          </li>
          <li @click="showfilter('select_gender')" :class="['li_select_gender', {'addborder': (activeTabsMobile === 'select_gender')}]">
            <img src="~images/project/icon/gender_icon.svg" alt="">
          </li>
          <li @click="showfilter('select_yr_exp')" :class="['li_select_yr_exp', {'addborder': (activeTabsMobile === 'select_yr_exp')}]">
            <img src="~images/project/icon/yr_icon.svg" alt="">
          </li>
          <li @click="showfilter('select_type')" :class="['li_select_type', {'addborder': (activeTabsMobile === 'select_type')}]">
            <img src="~images/project/icon/type_icon.svg" alt="">
          </li>
         <li @click="showfilter('select_consti')" :class="['li_select_consti', {'addborder': (activeTabsMobile === 'select_consti')}]">
            <img src="~images/project/icon/consti_icon.svg" alt="">
          </li>
          <!-- <li @click="showfilter('input')" :class="['li_input', {'addborder': (activeTabsMobile === 'input')}]">
            <img src="~images/project/icon/search_icon.svg" alt="">
          </li> -->
        </ul>
      </div>
      <div class="filters">
        <!-- <select class="singleSelect select_4G" name="" v-model="filterValues.fourG">
          <option value="">4G</option>
          <option :value="fourG" v-for="(fourG, index) in fiterItems.fourG">{{checkNY(fourG)}}</option>
        </select> -->
        <select class="singleSelect select_age" name="" v-model="filterValues.age">
          <option value="">AGE</option>
          <option :value="1">40 and below </option>
          <option :value="2">41 to 59</option>
          <option :value="3">60 and above</option>
        </select>
        <select class="singleSelect select_gender" name="" v-model="filterValues.gender">
          <option value="">GENDER</option>
          <option :value="gender" v-for="(gender, index) in fiterItems.gender" :key="index" >{{checkgender(gender)}}</option>
        </select>
        <select class="singleSelect select_yr_exp" name="" v-model="filterValues.yr_exp">
          <option value="">YRS. IN POLITICS</option>
          <option :value="1">0 to 10</option>
          <option :value="2">11 to 25</option>
          <option :value="3">26 and above</option>
        </select>
        <select class="singleSelect select_type" name="" v-model="filterValues.type">
          <option value="">TYPE</option>
          <option :value="type" v-for="(type, index) in fiterItems.type" :key="index">{{type}}</option>
        </select>
        <select class="singleSelect select_consti" name="" v-model="filterValues.consti">
          <option value="">CONSTITUENCY</option>
          <option :value="consti" v-for="(consti, index) in fiterItems.consti" :key="index">{{consti}}</option>
        </select>
        <!-- <input class="typeahead" type="text" name="text-search" v-model="filterValues.text" placeholder="Enter Name"> -->
      </div>
    </div>
    <template v-if="filteredCabinet.length > 0">
      <!-- <h4 class="subtitle">{{attributes.value.cabinet_label}}</h4> -->
      <minister-list :data="filteredCabinet" class="cabinet-content" />
    </template>
    <!-- adding new -->
    <!-- <template v-if="filteredMinorCabinet.length > 0">
      <hr class="dotted" />
      <h4 class="subtitle">{{attributes.value.minor_cabinet_label}}</h4>
      <minister-list :data="minor_cabinet_label" class="cabinet-content" />
    </template> -->
    <template v-if="filteredNonCabinet.length > 0">
      <hr class="dotted" />
      <h4 class="subtitle">{{attributes.value.noncabinet_label}}</h4>
      <minister-list :data="filteredNonCabinet" class="cabinet-content" />
    </template>

    <template v-if="filteredSection3.length > 0">
      <hr class="dotted" />
      <h4 class="subtitle">{{attributes.value.section3_label}}</h4>
      <minister-list :data="filteredSection3" class="retired-content" />
    </template>

     <template v-if="filteredSection4 && filteredSection4.length > 0"> 
      <hr class="dotted" />
      <h4 class="subtitle">{{attributes.value.section4_label}}</h4>
      <minister-list :data="filteredSection4" class="retired-content2" />
    </template>

    <st-model :content="modelData" v-if="modelData !== null" ></st-model>
  </div>
</template>

<script>
import $ from 'jquery'
import 'select2' 
require('typeahead.js/dist/typeahead.jquery.js')
import {store} from './../ProjectStore.js'
import StModel from './../Model.vue'
import MinisterList from './MinisterList.vue'

// var substringMatcher = function (strs) {
//   return function findMatches (q, cb) {
//     var matches, substrRegex;

//     // an array that will be populated with substring matches
//     matches = [];

//     // regex used to determine if a string contains the substring `q`
//     substrRegex = new RegExp(q, 'i');

//     // iterate through the pool of strings and for any string that
//     // contains the substring `q`, add it to the `matches` array
//     $.each(strs, function(i, str) {
//       if(substrRegex.test(str)) {
//         matches.push(str);
//       }
//     });

//     cb(matches);
//   };
// };

export default {
  props: ['attributes'],
  components: {MinisterList, StModel},
  data () {
    return {
      activeTabsMobile: 'select_age',
      member_name: [],
      fiterItems: {
        fourG: [],
        age: [],
        gender: [],
        ministry: [],
        yr_exp: [],
        type: [],
        consti: []
      },
      filterValues: {
        text: '',
        fourG: '',
        age: '',
        gender: '',
        ministry: '',
        yr_exp: '',
        type:'',
        consti: ''
      }
    }
  },
  computed: {
    dataset () {
      return store.dataset
    },
    modelData () {
      return store.modelData
    },
    filteredCabinet () {
      return store.cabinet
    },
    filteredSection3 () {
      return store.section3
    },
    filteredSection4 () {
      return store.section4
    },
    filteredNonCabinet () {
      return store.nonCabinet
    }
  },
  created () {
    if (typeof this.attributes.value.dataset !== 'undefined') this.fetchData(this.attributes.value.dataset)
  },
  mounted () {
    $('.singleSelect').select2({
      minimumResultsForSearch: Infinity,
      width: '100%'
    })
    var _this = this
    // $(document).on('change', '.select_4G', function () {
    //   _this.filterValues.fourG = $('.select_4G').val()
    //   _this.updateFilterValues()
    //   // Analytics
    //   _this.$analytics.getClient(store.projectName).track('filter', {
    //     'filter': 'select_4G',
    //     'filter_value': (_this.filterValues.fourG !== '') ? _this.filterValues.fourG : 'all'
    //   })
    // })
    $(document).on('change', '.select_type', function () { // test
      _this.filterValues.type = $('.select_type').val()
      _this.updateFilterValues()
      // Analytics
      _this.$analytics.getClient(store.projectName).track('filter', {
        'filter': 'select_type',
        'filter_value': (_this.filterValues.type !== '') ? _this.filterValues.type : 'all'
      })
    })
    $(document).on('change', '.select_consti', function () { // test
          _this.filterValues.consti = $('.select_consti').val()
          _this.updateFilterValues()
          // Analytics
          _this.$analytics.getClient(store.projectName).track('filter', {
            'filter': 'select_consti',
            'filter_value': (_this.filterValues.consti !== '') ? _this.filterValues.consti : 'all'
          })
        })
   $(document).on('change', '.select_age', function () {
      _this.filterValues.age = $('.select_age').val()
      _this.updateFilterValues()
      // Analytics
      _this.$analytics.getClient(store.projectName).track('filter', {
        'filter': 'select_age',
        'filter_value': (_this.filterValues.age !== '') ? _this.filterValues.age : 'all'
      })
    })
    $(document).on('change', '.select_gender', function () {
      _this.filterValues.gender = $('.select_gender').val()
      _this.updateFilterValues()
      // Analytics
      _this.$analytics.getClient(store.projectName).track('filter', {
        'filter': 'select_gender',
        'filter_value': (_this.filterValues.gender !== '') ? _this.filterValues.gender : 'all'
      })
    })
    $(document).on('change', '.select_ministry', function () {
      _this.filterValues.ministry = $('.select_ministry').val()
      _this.updateFilterValues()
      // Analytics
      _this.$analytics.getClient(store.projectName).track('filter', {
        'filter': 'select_ministry',
        'filter_value': (_this.filterValues.ministry !== '') ? _this.filterValues.ministry : 'all'
      })
    })
    $(document).on('change', '.select_yr_exp', function () {
      _this.filterValues.yr_exp = $('.select_yr_exp').val()
      _this.updateFilterValues()
      // Analytics
      _this.$analytics.getClient(store.projectName).track('filter', {
        'filter': 'select_yr_exp',
        'filter_value': (_this.filterValues.yr_exp !== '') ? _this.filterValues.yr_exp : 'all'
      })
    })
  },
  methods: {
    fetchData (path) {
      Promise.all([fetch(`${store.BUCKET_URL}${path}`).then(res => res.json())]).then((data) => {
        data = [...data].shift().slice(1) // skip first row for subheader
        store.dataset = data
        this.getFiterItems()
        this.prepareTypeahead()
      })
    },
    getFiterItems () { //check if cabinet 
      this.member_name = []
      this.clearDataCapsule()
      Object.values(store.dataset).forEach((data) => {
        // this.updateDataCapsule(data)
        // this.member_name.push(data.name)
        // if (typeof data['cabinet'] != 'undefined' && data['cabinet'].trim().toLowerCase() === 'n') { // second section
        //   store.nonCabinet.push(data)
        // } else {
        //     store.cabinet.push(data)
        //     this.member_name.push(data.name)
        // }

        // adding new
        // if (data['section'] === 2) { // second section
        //     store.nonCabinet.push(data)
        // } else if (data['section'] === 3) { // thrid
        //   store.minorCabinet.push(data)
        // } else {
        //   store.cabinet.push(data)
        //   this.member_name.push(data.name)
        // }

        // if (data['section'] === 1 || data['section'] === 2 ||data['section'] === 3 ) { // second section
        //   if (data['section'] === 1) {
        //     store.cabinet.push(data)
        //   } else if (data['section'] === 2) {
        //     store.nonCabinet.push(data)
        //   } else {
        //     console.log("3~~~~~~~~~~~~~~~~~~~~~~")
        //     console.log(store.section3)
        //     store.section3.push(data)
        //   } 
        // } else {
        //   console.log("4~~~~~~~~~~~~~~~~~~~~~~")
        //   console.log(store.section4)
        //   store.section4.push(data)
        // }

        if (data['section'] === 1 || data['section'] === 2 || data['section'] === 3 ) { // second section
          if (data['section'] === 1) {
            store.cabinet.push(data)
          } else if (data['section'] === 2) {
            store.nonCabinet.push(data)
          } else {
            // console.log("3~~~~~~~~~~~~~~~~~~~~~~")
            // console.log(store.section4)
            store.section3.push(data)
          } 
        } else {
          // console.log("4~~~~~~~~~~~~~~~~~~~~~~")
          // console.log(store.section)
          store.section4.push(data) 
        }



        this.addUniqueItemToArray(this.fiterItems.fourG, data['4g'])
        this.addUniqueItemToArray(this.fiterItems.age, data['age'])
        this.addUniqueItemToArray(this.fiterItems.gender, data['gender'])
        this.addUniqueItemToArray(this.fiterItems.ministry, data['ministry-1'])
        this.addUniqueItemToArray(this.fiterItems.ministry, data['ministry-2'])
        this.addUniqueItemToArray(this.fiterItems.ministry, data['ministry-3'])
        this.addUniqueItemToArray(this.fiterItems.yr_exp, data['yr_experience'])
        this.addUniqueItemToArray(this.fiterItems.type, data['type'])
        this.addUniqueItemToArray(this.fiterItems.consti, data['constituency'])

      })
      this.fiterItems.consti.sort()      
      this.fiterItems.age.sort()
      this.fiterItems.gender.sort()
      this.fiterItems.ministry.sort()
      this.fiterItems.type.sort()
      this.fiterItems.yr_exp.sort((a, b) => {
        return a - b
      })
    },
    prepareTypeahead () {
      var _this = this
      $('.typeahead').typeahead({
        hint: true,
        highlight: true,
        minLength: 1
      }, {
        name: 'all_name',
        source: _this.substringMatcher(_this.member_name)
      })
      .on("keyup focus", function () {
        if (!$(this).val()) {
          $(this).removeClass('borderradiusupdate');
          _this.updateFilterValues()
        } else {
          if ($(".tt-menu").hasClass("tt-empty") || !$(".tt-menu").hasClass("tt-open")) {
            $(this).removeClass('borderradiusupdate')
          } else {
            $(this).addClass('borderradiusupdate')
          }
        }
      })
      .on("typeahead:close", function () {
        $(this).removeClass('borderradiusupdate')
      })
      .bind('typeahead:select', function (ev, suggestion) {
        _this.filterValues.text = suggestion
        _this.updateFilterValues()
        // Analytics
        _this.$analytics.getClient(store.projectName).track('filter', {
          'filter': 'input',
          'filter_value': _this.filterValues.text
        })
      })
    },
    addUniqueItemToArray: function (arr, d) {
      if (!d) return
      if (d == '-') return
      if (arr.indexOf(d) !== -1) return
      if (typeof d !== 'undefined') {
        arr.push(d)
      }
    },
    checkNY(text) {
      if(text == "N") return "No";
      else if(text === "Y") return "Yes";
    },
    checkgender(text) {
      if(text == "F") return "Female";
      else if(text == "M") return "Male";
    },
    updateFilterValues () {
      this.clearDataCapsule()
      var filteredDataset = store.dataset.filter((data) => {
        return this.isItemMatchingFilter(data)
      })
      Object.values(filteredDataset).forEach((data) => {
        this.updateDataCapsule(data)
      })
    },
    updateDataCapsule (data) {

        if (data['section'] === 1 || data['section'] === 2 ||data['section'] === 3 ) { // second section
          if (data['section'] === 1) {
            store.cabinet.push(data)
          } else if (data['section'] === 2) {
            store.nonCabinet.push(data)
          } else {
            store.section3.push(data)
          } 
        } else {
          store.section4.push(data)
        }
    },
    clearDataCapsule () {
      store.cabinet = []
      store.nonCabinet = []
      store.section3 = []
      store.section4 = []
},
    showfilter (classname) {
      $(".visible-xs").show()
      if (classname === "input") {
        $(".singleSelect").next(".select2-container").hide()
        $("input").width("100%")
        $("input").addClass("removeborder")
        $("input").show()
        $("li").removeClass("addborder")
        $(".li_" + classname).addClass("addborder")
      } else {
        $(".singleSelect").next(".select2-container").hide()
        $("input").hide()
        $("li").removeClass("addborder");
        $(".li_" + classname).addClass("addborder")
        $("." + classname).next(".select2-container").show()
      }
    },
    substringMatcher (strs) {
      var _this = this
      return function findMatches (q, cb) {
        var matches, substrRegex
        // an array that will be populated with substring matches
        matches = []
        // regex used to determine if a string contains the substring `q`
        substrRegex = new RegExp(q, 'i')
        // iterate through the pool of strings and for any string that
        // contains the substring `q`, add it to the `matches` array
        $.each(strs, function (i, str) {
          if (substrRegex.test(str)) {
            matches.push(str)
          }
        })
        cb(matches)
        _this.updateFilterValues()
      }
    },
    isItemMatchingFilter (d) { 
      var _vm = this;

      // var textFilter = (_vm.filterValues.text && _vm.filter.text != '') ? (d.name.toLowerCase().indexOf(_vm.filter.text.toLowerCase().trim()) !== -1) : true;
      
      var textFilter = true;
      if(_vm.filterValues.text && _vm.filterValues.text !== '') {
        var nameFilter = (d['name'].toLowerCase().indexOf(_vm.filterValues.text.toLowerCase()) !== -1);
        // var designationFilter = (d['designation'].toLowerCase().indexOf(_vm.filterValues.text.toLowerCase()) !== -1);
        // textFilter = nameFilter || designationFilter;
        textFilter = nameFilter;
      }

      var fourGFilter = true;
      if(_vm.filterValues.fourG && _vm.filterValues.fourG !== '' && typeof d['4g'] !== 'undefined') {
        fourGFilter = (d['4g'].trim().toLowerCase() === _vm.filterValues.fourG.toLowerCase());
      }

      var genderFilter = true;
      if(_vm.filterValues.gender && _vm.filterValues.gender !== '' && typeof d['gender'] !== 'undefined') {
        genderFilter = (d['gender'].toLowerCase() === _vm.filterValues.gender.toLowerCase());
      }

      var ministryFilter = true;
      if(_vm.filterValues.ministry && _vm.filterValues.ministry !== '' && typeof d['ministry-1'] !== 'undefined') {
        ministryFilter = (d['ministry-1'].toLowerCase() === _vm.filterValues.ministry.toLowerCase()) || (d['ministry-2'].toLowerCase() === _vm.filterValues.ministry.toLowerCase()) || (d['ministry-3'].toLowerCase() === _vm.filterValues.ministry.toLowerCase());
      }

      var ageFilter = true;
      if(_vm.filterValues.age && _vm.filterValues.age !== '') {
        var minVal, maxVal;
        if(_vm.filterValues.age == '1') {
          minVal = 26;
          maxVal = 40;
        } else if(_vm.filterValues.age == '2') {
          minVal = 41;
          maxVal = 59;
        } else if(_vm.filterValues.age == '3') {
          minVal = 60;
          maxVal = 100;
        } else {
          minVal = 1;
          maxVal = 100;
        }
        ageFilter = (parseInt(d['age']) >= minVal) && (parseInt(d['age']) <= maxVal);
      }

      var yrExpFilter = true;
      if(_vm.filterValues.yr_exp && _vm.filterValues.yr_exp != '') {
        var minVal, maxVal;
        if(_vm.filterValues.yr_exp == '1') {
          minVal = 0;
          maxVal = 10;
        } else if(_vm.filterValues.yr_exp == '2') {
          minVal = 11;
          maxVal = 25;
        } else if(_vm.filterValues.yr_exp == '3') {
          minVal = 26;
          maxVal = 100;
        } else {
          minVal = 0;
          maxVal = 100;
        }
        yrExpFilter = (parseInt(d['yr_experience']) >= minVal) && (parseInt(d['yr_experience']) <= maxVal);
      }

      var typeFilter = true; // test
      if(_vm.filterValues.type && _vm.filterValues.type !== '' && typeof d['type'] !== 'undefined') {
        typeFilter = (d['type'].toLowerCase() === _vm.filterValues.type.toLowerCase());
      }

      var constiFilter = true; // test
      if(_vm.filterValues.consti && _vm.filterValues.consti !== '' && typeof d['constituency'] !== 'undefined') {
        constiFilter = (d['constituency'].toLowerCase() === _vm.filterValues.consti.toLowerCase());
      }
      
      var finalFilter = textFilter && fourGFilter && genderFilter && ministryFilter && ageFilter && yrExpFilter && constiFilter  && typeFilter;
      return finalFilter
    }
  }
}
</script>

<style lang="scss">
.grid-section {
  max-width: $d_large;
  margin: 0 auto;
  @media (max-width: 880px) {
    &.model-open {
      background-color: #fff;
      & > *:not(.st-model) {
        visibility: hidden;
      }
    }
  }
  .content_filters {
    border-bottom: 1px solid #ccc;
    max-width: 1100px;
    margin: 0 auto 40px;
    font-family: $font-CuratorRegular;
    @include breakpoint(880px) {
        border-bottom: 0;
    }
    .filters {
      text-align: center;
      .singleSelect, .select2, input {
        width: 100%;
        @include breakpoint(880px) {
          width: 160px !important;
          margin: 0 5px;
        }
      }
      @media(max-width: 879px) {
        input {
          border: 0;
          width: 100% !important;
        }
      }
    }
    .visible-xs {
      @include breakpoint(880px) {
        display: none;
      }
      .nav-tabs {
        border-bottom: 1px solid #ccc;
        .addborder {
          border: 1px solid #ccc;
          border-bottom: 1px solid #fff;
        }
        li {
          cursor: pointer;
          display: inline-block;
          margin-bottom: -1px;
          margin-left: 1px;
          &:first-of-type {
            margin-left: 10px;
          }
          img {
            width: 30px;
            height: 30px;
            margin: 10px 10px -5px;
          }
        }
      }
    }
    input {
      border-radius: 50px;
      border: 1px solid rgba(51,51,51,0.8);
      font-family: $font-CuratorRegular;
      font-size: 16px;
      color: $black;
      padding: 7px 0 7px 10px;
      box-sizing: border-box;
      height: 36px;
      &:focus {
        outline: none;
        &::-webkit-input-placeholder {
          color: transparent;
        }
        &:-moz-placeholder {
          color: transparent;
        }
      }
      &::-webkit-input-placeholder {
        font-size: $font-CuratorRegular;
      }
      &:-moz-placeholder {
        font-size: $font-CuratorRegular;
      }
      &.borderradiusupdate {
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
  .dotted {
    border-top: 1px dotted #ccc;
  }
  .subtitle {
    margin-top: 40px;
    margin-bottom: 20px;
  }
  .cabinet-group-title {
    font-family: $font-CuratorBold;
    font-size: 16px;
    margin-top: 20px;
  }
  .label-data p {
    @media (max-width: $d_medium) {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 10px;
    }
  }
}

.caption{
  color:#747d86;
  font-family: $font-CuratorRegular;
  font-size: 15px;
  display: block;
  margin-top: 10px;
  line-height: 22px;
  display: none;
}
.st-scrolly strong:first-of-type {
  // color: #fff;
  // background: #DF8526;
  font-family: $font-CuratorBold;
  font-size: 18px;
}
</style>
